'use client'

// import { useSearchStore } from '@stores/search.store'
import { MouseEvent, useState } from 'react'

import Image from 'next/image'

import { RestResponse } from '@types'

// import { useChatContext } from '@contexts/chat.context'
import useHttpRequest from '@hooks/useHttpRequest'

// import { jobApplyButtonClickedEvent } from '@lib/analytics-events'
// import { sendGTMEvent } from '@lib/helpers/client'
import saveIcon from '@images/saved-jobs/save.svg'
import savedIcon from '@images/saved-jobs/saved.svg'

import styles from './job-card.module.scss'

type JobCardLoggedInFeaturesProps = {
  jobId: string
  showBookmark: boolean
}

const JobCardLoggedInFeatures = ({ jobId, showBookmark }: JobCardLoggedInFeaturesProps): JSX.Element => {
  // const [isApplied, setIsApplied] = useState<boolean>(false)
  const [isSaved, setIsSaved] = useState<boolean>(showBookmark)
  const [isSaving, setIsSaving] = useState<boolean>(false)
  // const search = useSearchStore((state) => state.search)
  const { post } = useHttpRequest()
  // const { apply } = useChatContext()

  // const applyClick = async (event: MouseEvent): Promise<void> => {
  //   if (!isApplied) {
  //     event.preventDefault()
  //     event.stopPropagation()
  //     const eventData = {
  //       event_label: job.id || '',
  //       jobId: job.id || '',
  //       jobTitle: job.title || '',
  //       jobFeed: job.feed || '',
  //       jobGroupCategory: job.groupCategory || '',
  //       jobSource: job.source || '',
  //       jobCompanyName: job.companyName || '',
  //       searchMicroRole: search.job.micro || '',
  //       searchMacroRole: search.job.macro || '',
  //       searchLocationName: search.location.name || '',
  //       searchLocationType: search.location.type || '',
  //       searchLocationId: search.location.id || '',
  //       non_interaction: true,
  //       chat_mass_apply: false,
  //     }
  //     if (job?.id) {
  //       window.dataLayer.push({ 'Job ID': job?.id })
  //     }
  //     sendGTMEvent('beginApplication')
  //     jobApplyButtonClickedEvent(job, search)
  //     apply([job.id], setIsApplied, eventData)
  //   }
  // }

  const saveJob = async (event: MouseEvent): Promise<void> => {
    event.preventDefault()
    event.stopPropagation()
    if (!isSaving) {
      setIsSaving(true)
      if (isSaved) {
        const result = await post<RestResponse<string>>('savedjobs/delete', {
          body: {
            jobIds: [jobId],
          },
        })
        if (result?.data === 'Saved Jobs deleted successfully') {
          setIsSaved(false)
        }
      } else {
        const result = await post<RestResponse<string>>('savedjobs/save', {
          body: {
            jobIds: [jobId],
          },
        })
        if (result?.data === 'Jobs saved successfully') {
          setIsSaved(true)
        }
      }
      setIsSaving(false)
    }
  }

  return (
    <>
      <hr className={styles['option-message-hr']} />
      <div className={styles['option-message']}>
        {/* <div className={styles.grid}> */}
        <div className={styles.save} onClick={saveJob}>
          <p>{isSaved ? 'Job saved' : 'Save this job'}</p>
          {isSaved || <Image src={saveIcon} alt="Save" width="22" height="22" />}
          {isSaved && <Image src={savedIcon} alt="Saved" width="22" height="22" />}
        </div>
        {/* {false && (
              <div className={styles['one-tap-apply']} onClick={applyClick}>
                Quick apply
              </div>
            )} */}
        {/* </div> */}
        {/* {isApplied && (
          <>
            <div className={styles.applied}>You have applied to this job!</div>
          </>
        )} */}
      </div>
    </>
  )
}

export default JobCardLoggedInFeatures
